import { connect } from 'react-redux'
import Path from '@leverege/path'
import React from 'react'
import PropTypes from 'prop-types'

import PatchOps from '@leverege/api-patch-ops'
import { ScriptActions, BreadcrumbActions, UserActions } from '~/actions'
import { ScriptFactory } from '~/editors/script'

import style from './style.css'

const EDITED_CODE_PATH = 'scriptData/deployedCode'

class ScriptDeployedCodeScreen extends React.Component {

  componentDidMount() {
    this.props.dispatch( ScriptActions.get( this.props.match.params.projectId, this.props.match.params.scriptId ) )
    // let profile
    // try {
    //   profile = JSON.parse( localStorage.getItem( 'profile' ) )
    // } catch ( ex ) {
    //   // sad
    // }
    // if ( profile ) {
    //   this.context.store.dispatch( UserActions.get( profile.id ) )
    // }
  }

  componentWillReceiveProps( next ) {
    const { scripts } = next
    const { params } = this.props.match
    const scriptId = params.scriptId
    const script = scripts.lookup[scriptId]

    if ( script ) {
      this.props.dispatch( BreadcrumbActions.setBreadcrumbs( 
        [ { name : 'Scripts', link : `/project/${script.projectId}/script` }, 
          { name : script.name } ] ) )
    }
  
  }
  
  onScriptChange = ( { target, path, value } ) => {
    const { scripts } = this.props
    const { params } = this.props.match

    const scriptId = params.scriptId
    const script = scripts.lookup[scriptId]
    if ( script == null ) {
      return
    }
    if ( path === 'deployedCode' ) {
      this.props.dispatch( ScriptActions.undeploy( params.projectId, script ) )
    }
  }

  onUserChange = ( { target, path, value } ) => {

    let profile
    try {
      profile = JSON.parse( localStorage.getItem( 'profile' ) )
    } catch ( ex ) {
      // sad
    }

    const patchOps = PatchOps().replace( path, value ).ops()
    this.props.dispatch( UserActions.update( target, patchOps ) ).then( ( data ) => {
      if ( data && profile ) {
        Path( path ).set( profile, value )
        localStorage.setItem( 'profile', JSON.stringify( profile ) )
        this.forceUpdate()
      }
    } )
  }

  render() {
    const { scripts } = this.props
    const { params } = this.props.match

    let profile
    try {
      profile = JSON.parse( localStorage.getItem( 'profile' ) )
    } catch ( ex ) {
      // sad
    }

    const scriptId = params.scriptId
    const script = scripts.lookup[scriptId]
    const editedCode = Path( EDITED_CODE_PATH ).get( script, '' )
    if ( script == null ) {
      return null
    }
    const details = ScriptFactory.createCodeEditor( script, {
      headerText : 'This is the code that is currently deployed.',
      onChangeUser : this.onUserChange,
      onChange : this.onScriptChange,
      scriptPath : EDITED_CODE_PATH,
      themeOverride : 'github',
      actionText : 'Undeploy',
      disabled : true,
      user : profile,
      editedCode
    } )
    return <div className={style.editor}>{details}</div>
  }
}

export default connect(
  state => ( {
    scripts : state.scripts,
    // users : state.users
  } )
)( ScriptDeployedCodeScreen )
